import React, { Component } from "react";
import { Row, Col, Alert } from "react-bootstrap";
import "openlayers/css/ol.css";
import EventMapDrawing from "src/component/SafetyMap/EventMapDrawing";
import Loader from "src/js/Loader.js";
import { msgs } from 'src/js/ErrorMessage.js';
import 'src/i18n';
import { withTranslation } from 'react-i18next';

class EventMap extends Component {
  constructor(prop) {
    super(prop);

    this.state = {
      radius: 12,
      blur: 20
    };

    const mapId = "MapCmpMain" + Math.random();
    this.mapId = mapId;
    this.logCarId = prop.logCarId;
    this.safetyMapData = prop.safetyMapData;
    this.accidentDataList = prop.accidentDataList;
    this.selectPeriodFrom = prop.eventPeriodFrom;
    this.selectPeriodTo = prop.eventPeriodTo;
    this.radius = this.state.radius;
    this.blur = this.state.blur;

    this.handleBlurChange = this.handleBlurChange.bind(this);
    this.handleRadiusChange = this.handleRadiusChange.bind(this);
  }

  componentDidMount() {
    if (this.startTime !== "") {
      this.map = new EventMapDrawing(
        this.mapId,
        this.safetyMapData,
        this.accidentDataList,
        this.logCarId,
        this.selectPeriodFrom, 
        this.selectPeriodTo,
        this.state.radius,
        this.state.blur
      );

      this.heatMapLayer = this.map.heatMapLayer;
    }
  }

  handleRadiusChange(e) {
    this.setState({
      radius: e.target.value
    });
  }

  handleBlurChange(e) {
    this.setState({
      blur: e.target.value
    });
  }

  render() {
    const {t} = this.props;
    const Error = () => (
      <div>
        {(() => {
          if (!this.props.isAccidentData) {
            return (<Alert bsStyle="danger"><p>{t("Message." + msgs['msg_common_01'])}</p></Alert>)
          }
        })()}
      </div>
    )

    return (
      <div>
        <Row>
          <Col md={12} sm={12} xs={12}>
            <Error />
            <div className="map-col">
              <div id={this.mapId} className="MapCmpMain"></div>
              {this.props.safetyMapLoading ? (
                <div className="map-loader">
                  <Loader />
                </div>
              ) : (
                false
              )}
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default withTranslation()(EventMap);



// WEBPACK FOOTER //
// ./src/component/SafetyMap/EventMap.js